import React from 'react'

export const CrackWidthHelpHeader = (props) => (
  <h3>{'Average Crack Width'}</h3>
)

export const CrackWidthHelpBody = (props) => (
  <>
    <p className="intro">While determining the Average Crack Width, consider the shape of the crack or how it was formed. Below are some examples of ways to account for variances in the crack.</p>

    <section className="row">
        <div className="col-md-4" label="TBD" >
          <figure className="figure aceAvgCrackWidth">
            <figcaption className="figcaption">Even Crack</figcaption>
            <img className="illustration " src="https://embed.widencdn.net/svg/ssttoolbox/k8b991bidj/A_ACE_InstIll_Ill_Instld_AverageCrackWidth-EvenCrack_CY.svg" alt="Even Crack" />            
          </figure>
        </div>
        
        <div className="col-md-4" label="TBD">
          <figure className="figure aceAvgCrackWidth">
            <figcaption className="figcaption">Front Crack</figcaption>
            <img className="illustration " src="https://embed.widencdn.net/svg/ssttoolbox/91gwubr9by/A_ACE_InstIll_Ill_Instld_AverageCrackWidth-FrontCrack_CY.svg" alt="Front Crack" />            
          </figure>
        </div>
        
        <div className="col-md-4" label="TBD">
          <figure className="figure aceAvgCrackWidth">
            <figcaption className="figcaption">Top Crack</figcaption>
            <img className="illustration " src="https://embed.widencdn.net/svg/ssttoolbox/g54g697v4p/A_ACE_InstIll_Ill_Instld_AverageCrackWidth-TopCrack_CY.svg" alt="Top Crack" />            
          </figure>
        </div>
    </section>
  </>
)
